import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { OrganisationsService } from 'src/app/Services/organisations/organisations.service';
import { GroupsService } from 'src/app/Services/groups/groups.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/Services/notification/notification.service';
import { Group } from 'src/app/Models/Group';
import { CookieService } from 'ngx-cookie-service';
import { GroupUpdater, KeyValue } from 'src/app/Models/KeyValue';
import * as CryptoJS from 'crypto-js';
import { DataCache } from 'src/app/Helpers/data-cache';
import { TypeRoleGroup, TypeRoleGroupData } from 'src/app/Models/role';

@Component({
  selector: 'app-edit-group',
  templateUrl: './edit-group.component.html',
  styleUrls: ['./edit-group.component.css']
})
export class EditGroupComponent implements OnInit {
  OrgName: string;
  GroupName: string;
  GroupDesc: string;

  orgs = [];
  grp: any;

  isSave: boolean;
  loading: boolean;

  organisations = [];
  organisation: any;

  gs = [];

  adgroups1 = [];
  adgroups2 = [];

  types = [];
  type: any;

  constructor(
    private orgService: OrganisationsService,
    private groupService: GroupsService,
    private router: Router,
    public translate: TranslateService,
    private notificationSvc: NotificationService,
    private confirmationService: ConfirmationService,
    private cookieService: CookieService,
    private location: Location,
    private http: HttpClient
  ) {
    this.translate.addLangs(['English', 'French']);
    this.translate.setDefaultLang('English');

    let browserLang = this.translate.getBrowserLang();

    const pass = 'ranitessarldev2019';
    const lang = cookieService.get('goepla-portal-language');
    if (lang.trim() !== '') {
      const declang = CryptoJS.AES.decrypt(lang, pass).toString(CryptoJS.enc.Utf8);
      const lg = declang;
      browserLang = lg;
      localStorage.setItem('language', lg);

    }

    if (localStorage.getItem('language') !== null) {
      browserLang = localStorage.getItem('language');
    }
    this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.SELECTORGANISATION').subscribe((resp: string) => {
      this.organisations.push({label: resp + ' *', value: null});
    });

    this.grp = JSON.parse(localStorage.getItem('group'));

    this.getGroups();
    this.getOrganisation();
   }

  async ngOnInit() {
    this.GroupName = this.grp.groupName;
    this.GroupDesc = this.grp.groupDescription;
    this.type = this.grp.groupType;

    // this.getGroups();

    this.loading = true;
    const none = await this.translate.get('GENERAL.NONE').toPromise();

    this.types.push({label: none, value: null});

    const data = await DataCache.grouptypedata$.toPromise();
    this.type = this.types[0].value;
    if (data !== undefined && data !== null && data.length > 0) {
      for (const val of data) {
        this.types.push({label: val.groupTypeName, value: val});
        if (this.grp.groupType != null && this.grp.groupType !== undefined
          && val.groupTypeId === this.grp.groupType.groupTypeId) {
          this.type = val;
        }
      }
    }

    this.loading = false;
  }

  async getGroups() {
    this.loading = true;
    // tslint:disable-next-line: deprecation
    const res = await DataCache.groupdata$.toPromise();
    if (res != null) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < res.length; i++) {
        res[i].GroupName = res[i].groupName;
        this.gs.push(res[i]);
      }
      this.arrangeRoles();
    }
    this.loading = false;
  }

  arrangeRoles() {
    if (this.gs !== null && this.gs.length > 0) {
      if (this.grp.typeRoleGroups !== null && this.grp.typeRoleGroups.length > 0) {
        for (const v of this.gs) {
          let ad = true;
          for (const val of this.grp.typeRoleGroups) {
            if (val.typeRoleGroup.roleName === 'Administrator') {
              if (v.groupId === val.typeRoleGroup.groupId) {
                this.adgroups2.push(v);
                ad = false;
              }
            }
          }

          if (ad === true) {
            this.adgroups1.push(v);
          }
        }
      } else {
        for (const val of this.gs) {
          this.adgroups1.push(val);
        }
      }
    }
  }

  getOrganisation() {
    this.loading = true;
    // tslint:disable-next-line: deprecation
    this.orgService.getOrganisationById().subscribe((res) => {
      if (res != null) {
        this.organisation = res;
        this.OrgName = res.organisationName;
      }
      this.loading = false;
    });
  }

  onCancel() {
    // this.router.navigateByUrl('/groups');
    this.location.back();
  }

  onSave() {
    if (this.GroupDesc === undefined || this.GroupDesc === null || this.GroupDesc.trim() === '') {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.ENTERGROUPDESCRIPTION').subscribe((resp: string) => {
        this.confirm(resp);
      });
      return;
    }

    const upt = new GroupUpdater();
    upt.Id = this.grp.groupId;
    upt.Values = [];

    const desc = new KeyValue();
    desc.key = 'desc';
    desc.Value = this.GroupDesc;
    upt.Values.push(desc);

    const tp = new KeyValue();
    tp.key = 'type';
    upt.Values.push(tp);

    if (this.type !== undefined && this.type !== null) {
      tp.Value = this.type.groupTypeId;
    } else {
      tp.Value = '0';
    }

    const rgroups = [];
    if (this.adgroups2 !== null && this.adgroups2.length > 0) {
      for (const val of this.adgroups2) {
        const rgroup = new TypeRoleGroup();
        rgroup.GroupId = val.groupId;
        rgroup.ParentId = this.grp.groupId;
        rgroup.RoleName = 'Administrator';
        rgroup.RoleParentType = 'group';

        rgroups.push(rgroup);
      }
    }

    const data = new TypeRoleGroupData();
    data.ParentId = this.grp.groupId;
    data.RoleParentType = 'group';
    data.TypeRoleGroup = rgroups;

    const rg = new KeyValue();
    rg.key = 'role_groups';
    rg.Value = JSON.stringify(data);
    upt.Values.push(rg);

    this.loading = true;
    this.isSave = true;
    // tslint:disable-next-line: deprecation
    this.groupService.putGroup(this.grp.groupId, upt).subscribe((res) => {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.GROUPUPDATED').subscribe((resp: string) => {
        this.notificationSvc.info('', resp, 2000);
      });
      // this.router.navigateByUrl('/groups');
      this.location.back();
      this.isSave = false;
      this.loading = false;

      DataCache.loadData(this.http);
    }, err => {
      this.handleError(err);
    });
  }

  confirm(msg) {
    this.confirmationService.confirm({
        message: msg,
        accept: () => {
            // Actual logic to perform a confirmation
        }
    });
}

  handleError(err) {
    if (err.error.MessageText === 'duplicate key value violates unique constraint "t_usm_grp_org_id_grp_name_key"') {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.GROUPALREADYEXISTS').subscribe((resp: string) => {
        this.confirm(resp);
      });
    }

    this.isSave = false;
    this.loading = false;
  }
}
